import api from '@axios'
import interno from '@/navigation/vertical-interno'
import externo from '@/navigation/vertical-externo'
import propostaExterno from '@/navigation/vertical-proposta-externo'
import { isAccessNotAuthenticated } from '@/auth/utils'

export default async () => {
  if (!isAccessNotAuthenticated()) {
    const tipoMenu = await api.get('/seguranca/menu').then(payload => payload.data)
    if (tipoMenu === 1) {
      return interno
    } if (tipoMenu === 2) {
      return externo
    }
  } else if (isAccessNotAuthenticated()) {
    return propostaExterno
  }
  throw new Error('Nenhum menu encontrado para o login')
}
